import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const HamburgerStyled = styled("ul", {
  shouldForwardProp: (prop) => prop !== "toggled",
})<{ toggled: boolean }>`
  height: 1.2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: #fff;

  padding: 0;
  margin: 0;

  li {
    list-style: none;
    transition: 0.5s ease-in;
    width: 1.6rem;
    height: 0.2rem;
    background-color: ${({ theme }) => theme.colors.secondaryColor};
    transform-origin: 0;

    ${({ toggled }) =>
      toggled &&
      css`
        &:nth-of-type(1) {
          transform: rotate(45deg);
          width: 1.4rem;
        }

        &:nth-of-type(2) {
          transform: translateX(-10rem);
        }

        &:nth-of-type(3) {
          transform: rotate(-45deg);
          width: 1.4rem;
        }
      `}
  }
`;

export const NoStyledBtn = styled.button`
  border: none;
  background-color: transparent;
`;
